import type { CSSProperties } from 'react'
import {
  WORK_TYPE_LEVEL_META,
  type WorkTypeLevel,
} from '../../utils/workTypeLevels'

interface WorkTypeLevelBadgeProps {
  level: WorkTypeLevel
  className?: string
}

export function WorkTypeLevelBadge({ level, className = '' }: WorkTypeLevelBadgeProps) {
  const meta = WORK_TYPE_LEVEL_META[level]
  return (
    <span
      className={`inline-flex items-center justify-center w-7 h-7 rounded-full border bg-white/95 shadow-sm text-sm font-bold leading-none tabular-nums ${className}`}
      style={
        {
          color: meta.color,
          borderColor: `${meta.color}55`,
        } as CSSProperties
      }
      title={meta.filterLabel}
      aria-label={meta.filterLabel}
    >
      {level}
    </span>
  )
}
